import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { UniqueStaticFlow } from "@/features/CouponCodes/Static/StaticFlow";

const searchSchema = z.object({
  discountName: z.string().min(1),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/new/static",
)({
  validateSearch: zodValidator(searchSchema),
  component: StaticCouponCodeRoute,
});

function StaticCouponCodeRoute() {
  const { discountName } = Route.useSearch();
  const { siteId } = Route.useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes",
      params: { siteId },
    });
  };

  const handleBack = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes/new",
      params: { siteId },
      search: { discountName },
    });
  };

  return (
    <UniqueStaticFlow
      siteId={siteId}
      discountName={discountName}
      onClose={handleClose}
      onBack={handleBack}
    />
  );
}
